// EliminateProcessingFees.jsx
import React from "react";
import "../css/EliminateProcessingFees.css";
import logo from "../../assets/merchant-marvels.jpg";

/**
 * Usage:
 * <EliminateProcessingFees
 *   onGetStarted={() => {}}
 *   badgeLogoSrc="/images/slice-mark.png" // optional
 * />
 */
export default function EliminateProcessingFees({
  onCtaClick,
  heading = `0% Processing\nWill once and for all\nEliminate all Processing Fees`,
  body = `With the Merchant Marvels 0% Processing plan, you'll never have to worry about processing fees. Our exceptional customer service will make you a happy customer. Thousands of merchants are already using Merchant Marvels, and more are signing on every day.`,
  ctaText = "GET STARTED",
  footnote = "See if your business qualifies for 0% Processing",
  onGetStarted,
  badgeLogoSrc,
  tableTitleLeft = "Traditional\nProcessing",
  tableTitleRight = "Merchant Marvels\n0% Processing",
  rows,
}) {
  const defaultRows = [
    { label: "Interchange Fee", left: "2%-4% of Gross", right: "0%" },
    { label: "Transaction Fee", left: "$0.05-$0.25", right: "$0.00" },
    { label: "Authorization Fee", left: "$0.05-$0.25", right: "$0.00" },
    { label: "Statement Fee", left: "$5-$10/mo", right: "$0/mo" },
    { label: "Monthly Minimum", left: "$25-$50/mo", right: "$0/mo" },
    { label: "Online Access Fee", left: "$3-$15/mo", right: "$0/mo" },
    { label: "Other Junk Fees", left: "$1-$199/mo", right: "No junk fees" },
  ];

  const data = rows?.length ? rows : defaultRows;

  return (
    <section className="epf" aria-label="Eliminate all processing fees">
      <div className="epf__inner">
        {/* LEFT: comparison */}
        <div className="epf__left">
          <div className="epf__compare">
            {/* small flag icon above Traditional */}
            <div className="epf__flag" aria-hidden="true" />

            <div className="epf__grid">
              <div className="epf__col epf__labels" aria-hidden="false">
                <div className="epf__labelsHeader" aria-hidden="true" />
                {data.map((r) => (
                  <div className="epf__cell epf__label" key={r.label}>
                    {r.label}
                  </div>
                ))}
              </div>

              <div className="epf__col epf__traditional">
                <div className="epf__colHeader">
                  {tableTitleLeft.split("\n").map((t, i) => (
                    <div key={i} className="epf__colHeaderLine">
                      {t}
                    </div>
                  ))}
                </div>

                {data.map((r) => (
                  <div className="epf__cell epf__val" key={r.label}>
                    {r.left}
                  </div>
                ))}
              </div>

              <div className="epf__card">
                <div className="epf__cardHeader">
                  <img className="epf__logo" src={logo} alt="Slice" />

                  <div className="epf__cardTitle">
                    {tableTitleRight.split("\n").map((t, i) => (
                      <div key={i} className="epf__cardTitleLine">
                        {t}
                      </div>
                    ))}
                  </div>
                </div>

                <div className="epf__cardBody">
                  {data.map((r) => (
                    <div className="epf__cardVal" key={r.label}>
                      {r.right}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT: text */}
        <div className="epf__right">
          <h2 className="epf__heading">
            {heading.split("\n").map((line, i) => (
              <span key={i} className="epf__headingLine">
                {line}
              </span>
            ))}
          </h2>

          <p className="epf__body">{body}</p>

          <button
            className="epf__cta"
            type="button"
            // onClick={onCtaClick || (() => (window.location.hash = "products"))}
              onClick={() => (window.location.href = "/apply")}
          >
            {ctaText}
          </button>

          <div className="epf__footnote">{footnote}</div>
        </div>
      </div>
    </section>
  );
}